"use client";

export type ButtonProps = {
  title?: string;
  styleClass?: string;
  icon?: JSX.Element;
  disabled?: boolean;
  handleClick?: Function;
  children?: React.ReactNode;
  id?: string;
  trailingIcon?: JSX.Element;
  fullWidth?: boolean;
  formAction?: (formdata: FormData) => void;
  iconWidth?: string;
  iconHeight?: string;
  isSelected?: boolean;
  height?: string;
  trailingIconStyle?: string;
  iconStyle?: string;
};

function handleClick() {
  console.log("button without handler");
}

export default function Button({
  title,
  styleClass,
  icon,
  disabled,
  handleClick,
  children,
  id,
  trailingIcon,
  fullWidth,
  formAction,
  iconWidth,
  iconHeight,
  isSelected,
  height,
  trailingIconStyle,
  iconStyle,
}: ButtonProps) {
  return (
    <div className={fullWidth ? "buttonbase w-full h-full" : "buttonbase"}>
      <button
        disabled={disabled}
        className={
          (styleClass
            ? fullWidth
              ? styleClass + " w-full"
              : height
                ? height + " " + styleClass
                : styleClass + " h-10"
            : "button primary w-full h-10") + `${disabled ? " disabled " : ""} `
        }
        formAction={formAction}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          // e.preventDefault();
          handleClick
            ? handleClick()
            : () => console.log("button without handler");
        }}
        // onTouchStart={(e: React.TouchEvent<HTMLElement>) => {
        //   // e.preventDefault();
        //   handleClick
        //     ? handleClick()
        //     : () => console.log("button without handler");
        // }}
      >
        <div
          className={`inside-button flex flex-row gap-2 items-center content-center justify-center z-auto `}
        >
          {icon && (
            <div
              className={
                iconStyle +
                " " +
                (iconWidth && iconHeight ? iconWidth + " " + iconHeight : " ")
              }
            >
              {icon}
            </div>
          )}
          {title && (
            <span
              className={`text-nowrap text-sm font-medium  z-auto${
                icon ? "ms-1" : ""
              }`}
            >
              {title}
            </span>
          )}
          {children}
          {trailingIcon && (
            <div className={`icontrailing ${trailingIconStyle}`}>
              {trailingIcon}
            </div>
          )}
        </div>
      </button>
    </div>
  );
}
